/**
 * 랜딩 페이지 루트. 히어로 → 해봄이란? → 사업 실증 → 푸터를 세로로 배치한다.
 * LandingStyles 로 전용 CSS 를 주입하고, 체험/신청 모달을 열어 주는 역할.
 */
import React, { useState } from "react";
import Head from "next/head";
import LandingStyles from "./LandingStyles";
import LandingHeader from "./LandingHeader";
import LandingHero from "./LandingHero";
import LandingAbout from "./LandingAbout";
import LandingProof from "./LandingProof";
// 푸터는 운영 사이트와 완전히 같아야 해서 앱 푸터를 그대로 쓴다.
import Footer from "@/components/layout/Footer";
import LandingPlayModal from "./LandingPlayModal";
import LandingPlayPosterModal from "./LandingPlayPosterModal";
import useNewPlayFlow from "@/hooks/useNewPlayFlow";
import LandingApplyModal from "./LandingApplyModal";

import { color } from "@/constants/palette";
const TITLE = "해봄 - 길잡이별 검사로 시작하는 AI시대 진로탐색";
const DESCRIPTION =
  "해봄(구 디큐 DQ)은 한 시간짜리 설문으로 아이를 판정하지 않습니다. 길잡이별 검사로 학생이 실제로 무엇을 선택하고 어디에 머무는지를 기록해, 상담에 바로 쓰는 진로·역량 데이터로 만듭니다.";
const OG_DESCRIPTION = "객관식 대신 40분 스토리 미션. 강점과 진로분야를 찾습니다.";

/**
 * 비로그인 방문자용 랜딩 (원본: ../../../../landing2/index.html v3.2).
 *
 * 마크업·CSS·동작을 원본 그대로 옮기되 다음만 이 프로젝트에 맞췄습니다.
 *   · dq.ai.kr 절대 URL → 내부 라우트 (/login, /play, /play1, /help/faq, /privacy)
 *   · base64 로 박혀 있던 로고 4종 → public/images/landing/*.png
 *   · 폼 전송: SITE_CONFIG.formEndpoint → config.ts 의 getLandingFormEndpoint()
 *   · 푸터: 원본의 자체 푸터 대신 운영 사이트와 같은 앱 푸터(layout/Footer) 사용
 */
export default function LandingPage() {
  const [playOpen, setPlayOpen] = useState(false);
  // `?new=1` 이면 체험하기 개편판(포스터형) 모달, 아니면 기존 참여자 유형 모달.
  const isNewPlayFlow = useNewPlayFlow();
  const [applyOpen, setApplyOpen] = useState(false);

  return (
    <>
      <Head>
        {/* _app.tsx 의 기본 메타와 같은 key 를 써서 랜딩 값으로 덮어쓴다. og:url·canonical·og:image 는 _app 이 낸다. */}
        <title>{TITLE}</title>
        <meta key="description" name="description" content={DESCRIPTION} />
        <meta name="theme-color" content={color.white} />
        <meta key="og:title" property="og:title" content={TITLE} />
        <meta key="og:description" property="og:description" content={OG_DESCRIPTION} />
        {/*
          원본에 있던 Pretendard <link> 는 여기서 뺐다.
          _document.tsx 가 이미 같은 버전(v1.3.9)을 비차단으로 전역 로드하고 있어
          중복 요청만 늘고, next/head 로 stylesheet 를 넣지 말라는 경고도 뜹니다.
        */}
      </Head>

      <LandingStyles />

      <a className="sr-only skip-link" href="#main">
        본문으로 건너뛰기
      </a>

      <LandingHeader onPlayOpen={() => setPlayOpen(true)} />

      <main id="main">
        <LandingHero onApplyOpen={() => setApplyOpen(true)} />
        <LandingAbout />
        <LandingProof />
      </main>

      <Footer />

      {isNewPlayFlow ? (
        <LandingPlayPosterModal open={playOpen} onClose={() => setPlayOpen(false)} />
      ) : (
        <LandingPlayModal open={playOpen} onClose={() => setPlayOpen(false)} />
      )}
      <LandingApplyModal open={applyOpen} onClose={() => setApplyOpen(false)} />
    </>
  );
}
